import { render } from "./SettlementManagement.vue?vue&type=template&id=6c04eca6&scoped=true"
import script from "./SettlementManagement.vue?vue&type=script&lang=js"
export * from "./SettlementManagement.vue?vue&type=script&lang=js"

import "./SettlementManagement.vue?vue&type=style&index=0&id=6c04eca6&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c04eca6"]])

export default __exports__